<template>
  <div>
    <div
      ref="bienvenidaRef"
      class="bienvenida-container"
    >
      <div class="mensaje-container">
        <h2>Libro de Firmas.</h2>
        <textarea
          v-model="nuevoMensaje"
          placeholder="Tu mensaje aquí..."
          rows="4"
          maxlength="500"
          @input="verificarLongitud"
        />
        <div class="contador">
          {{ caracteresRestantes }} caracteres restantes
        </div>

        <input
          v-model="localNombre"
          type="text"
          placeholder="Tu nombre aquí..."
          class="nombre-input"
        >
        <button @click="enviarMensaje">
          Enviar
        </button>

        <div class="mensajes-enviados">
          <h3>Mensajes recibidos:</h3>
          <div
            v-for="(mensajeObj, index) in mensajes"
            :key="index"
            class="mensaje-tarjeta"
          >
            <strong>{{ mensajeObj.nombre }}:</strong> {{ mensajeObj.mensaje }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick, computed } from 'vue';
import axios from 'axios';
import baseUrl from '../api';  // Asegúrate de importar la URL base


export default {
  name: 'BienvenidaPage',
  props: {
    idInvitado: {
      type: Number,
      required: true,
      validator(value) {
        return !isNaN(value) && value > 0;
      }
    },
    nombre: {
      type: String,
      default: '',
    },
    idFestejado: {
      type: Number,
      default: null,
    }
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const nuevoMensaje = ref('');
    const localNombre = ref('');
    const mensajes = ref([]);
    const animationDone = ref(false);
    const maxCaracteres = 500; // Cambia este número según tus necesidades
    const caracteresRestantes = computed(() => maxCaracteres - nuevoMensaje.value.length);
  
    const verificarLongitud = () => {
      if (nuevoMensaje.value.length > 500) {
        nuevoMensaje.value = nuevoMensaje.value.slice(0, 500);
      }
    };
    // Función para obtener mensajes al montar el componente
    const obtenerMensajes = async () => {
      try {
        const response = await axios.get(`${baseUrl}/mensajes?idFestejado=${props.idFestejado}`);
        mensajes.value = response.data; // Asume que la respuesta es un array de objetos con nombre y mensaje
      } catch (error) {
        console.error('Error al obtener los mensajes:', error);
      }
    };

    const enviarMensaje = async () => {
      if (nuevoMensaje.value.trim() && localNombre.value.trim()) {
        console.log('Datos a enviar:', {
          mensaje: nuevoMensaje.value.trim(),
          idFestejado: props.idFestejado,
          idInvitado: props.idInvitado,
          nombre: localNombre.value.trim(),
        });

        try {
  const response = await axios.post(`${baseUrl}/mensajes`, {
    mensaje: nuevoMensaje.value.trim(),
    idFestejado: props.idFestejado,
    idInvitado: props.idInvitado,
    nombre: localNombre.value.trim(),
  });
          console.log(response.data); // Mensaje de éxito
          
          // Agregar el mensaje como objeto
          mensajes.value.push({
            nombre: localNombre.value.trim(),
            mensaje: nuevoMensaje.value.trim()
          });

          nuevoMensaje.value = '';
          localNombre.value = '';
        } catch (error) {
          console.error('Error al guardar el mensaje:', error);
        }
      }
    };

    onMounted(async () => {
      await obtenerMensajes(); // Llamar a la función para obtener mensajes
      await nextTick();
      if (bienvenidaRef.value) {
        const element = bienvenidaRef.value;

        const observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: [0.1],
        };

        const observerCallback = (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!animationDone.value) {
                element.classList.add('animate__animated', 'animate__fadeInUp');
                element.addEventListener('animationend', () => {
                  element.classList.remove('animate__animated', 'animate__fadeInUp');
                  element.style.opacity = '1';
                }, { once: true });

                animationDone.value = true;
              }
            } else {
              element.style.opacity = '0';
              animationDone.value = false;
            }
          });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(element);
      }
    });

    return { bienvenidaRef, nuevoMensaje, localNombre, mensajes, enviarMensaje,caracteresRestantes,verificarLongitud };
  },
};
</script>

<style scoped>
@font-face {
  font-family: 'FeelingPassionate';
  src: url('@/assets/fonts/passionate.ttf') format('truetype');
  font-display: block;
}

.bienvenida-container {
  position: relative;
  width: 100%;
  padding-top: 30px;
  background-color: rgba(217, 212, 209, 0.95);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;  opacity: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.5s;
}

.bienvenida-container:hover {
  transform: translateY(-5px);
}

.mensaje-container {
  width: 100%;
  max-width: 600px;
  padding: 30px;
  color: #1a1a1a;
  border-radius: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;
  font-family: 'padres';
}

.mensaje-container:hover {
  transform: scale(1.02);
}

.mensaje-container h2 {
  font-size: 25px;
  margin-bottom: 15px;
  text-align: center;
  font-family: 'Playfair Display', serif;
  background:    #282726;

  background-clip: text;
  color: transparent;
  animation: animateText 5s linear infinite;
}

@keyframes animateText {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: 0 0;
  }
}

textarea,
.nombre-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid rgba(52, 46, 44, 0.5);
  border-radius: 5px;
  font-family: 'padres';
  font-size: 14px;
}

textarea:focus,
input:focus {
  border-color: #1d1d1d;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  outline: none;
}

button {
  padding: 10px 24px;
  background: rgba(161, 151, 142, 0.95);  /* Color oscuro */
  color: white;
  border: none;
  font-family: 'padres';
  border-radius: 6px;
  font-size: 13px;
  letter-spacing: 2px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

button:hover {
  background-color: #333;
  transform: scale(1.05);
}

.contador {
  font-size: 13px;
  color: gray;
  text-align: right;
  margin-top: -5px;
  margin-bottom: 10px;
  font-family: 'padres';
}

.mensajes-enviados {
  margin-top: 25px;
  text-align: left;
  font-family: 'padres';
}

.mensajes-enviados h3 {
  font-size: 16px;
  margin-bottom: 10px;
}

.mensaje-tarjeta {
  background: rgba(255, 255, 255, 0.95);
  padding: 10px 12px;
  margin: 8px 0;
  border-radius: 6px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.mensaje-tarjeta:hover {
  transform: translateY(-3px);
}
</style>